import { Routes, Route } from "react-router";
import { useSelector } from "react-redux";
import { HasPermission } from "Core/security";
import { Navigate } from "react-router-dom";

//Views
import MaintenanceWarningEventsMain from "Modules/maintenanceWarningEvents/views/main";

const RouterMaintenanceWarningEvents = (props) => {
    const user = useSelector(state => state.securityRedux.user);

    return (
        <>
            <Routes>
                <Route path="list" element={<MaintenanceWarningEventsMain />} />
                <Route path="*" element={<Navigate to="/error" />} />
            </Routes>
        </>
    )
}
export default RouterMaintenanceWarningEvents;